/**
 * Search behaviour switch.
 *
 * SEARCH_MODE
 *   'internal' → search logs + opens /search?q=… showing matches from THIS
 *                site's own pages (titles + page content), plus a
 *                "search the web on DuckDuckGo" button. No external calls.
 *   'off'      → search logs + redirects straight to DuckDuckGo.
 *   'api'      → /search fetches web results from our API server
 *                (GET /api/web-search — Brave or Google JSON behind the
 *                scenes; see API-server/DEPLOY-SEARCHLOG.md). Parked until
 *                logging shows real search traffic.
 *   'widget'   → /search renders Google's PSE widget (branding + possible
 *                ads). Needs PSE_CX. Also parked.
 */
export const SEARCH_MODE = 'internal';

/** Google Programmable Search Engine ID (only used in 'widget' mode) */
export const PSE_CX = 'a3bd5b959176c41f9';

/** Our API server's web-search proxy (only used in 'api' mode) */
export const WEB_SEARCH_ENDPOINT = 'https://any-dns.co.uk/aw_api/api/web-search';

export const inPageSearchEnabled = () =>
  SEARCH_MODE === 'internal' ||
  SEARCH_MODE === 'api' ||
  (SEARCH_MODE === 'widget' && Boolean(PSE_CX));
